import React from 'react'

import {
  CustomAudiencesActions,
  CustomAudiencesReducer,
  INITIAL_STATE,
} from './reducer'

interface Context {
  state: CustomAudiencesReducer
  dispatch: React.Dispatch<CustomAudiencesActions>
}

const CustomAudiencesContext = React.createContext<Context>({
  state: INITIAL_STATE,
  dispatch: () => 0,
})

export default CustomAudiencesContext
